import { Button } from '@mui/material';
import { formatTimeSlot } from '@/utils/date';
import type { Timeslot } from '@/types';

interface TimeslotButtonProps {
  timeslot: Timeslot;
  selected?: boolean;
  onClick: (timeslot: Timeslot) => void;
  showDuration?: boolean;
}

export function TimeslotButton({
  timeslot,
  selected = false,
  onClick,
  showDuration = false,
}: TimeslotButtonProps) {
  return (
    <Button
      variant={selected ? 'contained' : 'outlined'}
      color="primary"
      onClick={() => onClick(timeslot)}
      sx={{
        minWidth: '120px',
        height: '48px',
      }}
    >
      {formatTimeSlot(timeslot.from, timeslot.to, showDuration)}
    </Button>
  );
}
